import { type MouseEventHandler } from 'react'
import { Button } from '@livechat/design-system-react-components'
import { Add, Remove } from '@livechat/design-system-icons'
import { css } from '@emotion/react'

const buttonCss = css`
  margin-block: 16px;
  text-decoration: none !important;
`

interface IExtendListButtonProps {
  isExtended: boolean
  handleExtend: MouseEventHandler
  agentCount: number
}

const ExtendListButton = ({
  isExtended,
  handleExtend,
  agentCount,
}: IExtendListButtonProps) => {
  return (
    <Button
      css={buttonCss}
      kind="link"
      onClick={handleExtend}
      icon={isExtended ? <Remove /> : <Add />}
    >
      show {agentCount} {isExtended ? 'less' : 'more'}
    </Button>
  )
}

export default ExtendListButton
